import { NavigateFunction } from 'react-router-dom';
import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { Response, Props } from './Types';

export const AUTH_TOKEN_NAME = '@Auth.token'

class AutenticacaoController {
  public static async Create(
    request: Props,
    navigate: NavigateFunction
  ): Promise<boolean> {
    try {
      console.log(request);
      console.log(navigate);
      return true;
    } catch (error: any) {
      throw new DOMException();
    }
  }

  public static async Login(request: Props): Promise<Response> {
    try {
      const { data, status } = await Api.post(`api/autenticacao/autenticar`, request);

      return { StatusCode: status, Data: data };
    } catch (error: any) {

      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error.response?.status),
      };
      return retorno;
    }
  }
}

export default AutenticacaoController;
